import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", null, "Magasins :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              modelValue: _ctx.client,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
                _ctx.handleAgencySelection
              ],
              options: _ctx.clientList,
              label: "store"
            }, {
              option: _withCtx(({ store, nb_colis }) => [
                _createElementVNode("span", null, _toDisplayString(store) + " - " + _toDisplayString(nb_colis) + " Colis", 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.auth.can('ADD_INV'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                style: {"float":"right"},
                variant: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addInvoice && _ctx.addInvoice(...args))),
                class: "btn btn-primary"
              }, " Ajouter "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}